var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-box dialog-mask",on:{"click":_vm.$close}},[_c('div',{staticClass:"dialog-content"},[_c('div',{staticClass:"dialog-body"},[_c('p',[_vm._v(_vm._s(_vm.content))])]),_c('footer',[_c('button',{staticClass:"spl-button",on:{"click":_vm.$close}},[_vm._v(" OK ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }